// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react'
import tw from 'tailwind-styled-components'

type Props = {
  $compact?: boolean
  $truncate?: boolean
  colspan?: number
}

const TableColumn = tw.td<Props>`
  border-b
  border-gray-200
  font-medium
  leading-5
  md:text-sm
  pl-6
  pr-3
  py-4
  text-gray-900
  text-xs

  ${({ $compact }: Props) => {
    if ($compact) {
      return `
        py-2
        pl-2
        pr-1
      `
    }

    return ''
  }}

  ${(props: Props) => {
    if (props.$truncate) {
      return `
        max-w-xs
        truncate
      `
    }

    return ''
  }}
`

export default TableColumn
